module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-markbox xsearch xsearch-padding"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "search-result"
  }, [_c('span', {
    staticClass: "xkeywords"
  }, [_vm._v(_vm._s(_vm.oldSearchKey))]), _vm._v("\n      " + _vm._s(_vm.$t('m.common')) + _vm._s(_vm.documentList.length) + _vm._s(_vm.$t('m.ssjg')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "searchbox"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('m.input_key')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchDoc.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.$store.state.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "searchKey", $$v)
      },
      expression: "$store.state.searchKey"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "twui-ico xsearch",
    on: {
      "click": _vm.searchDoc
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result-box"
  }, [(_vm.hasData) ? _c('div', _vm._l((_vm.documentList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', {
      staticClass: "xtit",
      domProps: {
        "innerHTML": _vm._s(item.titleHtml)
      },
      on: {
        "click": function($event) {
          return _vm.goToDoc(item.docId)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "xcont"
    }, [_vm._v(_vm._s(item.content))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.hasData) ? _c('div', {
    staticClass: "nodata-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/dev/images/nodata.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('m.mycxdjl')))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-36122fd9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/doc/search.vue
// module id = 592
// module chunks = 1